var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialLinkTwitter = function SvgSocialLinkTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 62 78"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M45.2 1H16.8C8.074 1 1 8.074 1 16.8v28.4C1 53.926 8.074 61 16.8 61h3.098v13.136c0 1.284 1.076 2.326 2.362 2.326s2.362-1.042 2.362-2.326v-9.358c0-.9.754-1.632 1.658-1.632s1.612.73 1.612 1.632l-.03 8.478v.024c0 1.286 1.078 2.328 2.362 2.328s2.362-1.04 2.362-2.328v-9.856a1.629 1.629 0 1 1 3.256 0l-.016 1.236v5.166c0 1.284 1.01 2.326 2.296 2.326s2.294-1.042 2.294-2.326v-7.218c0-.808.63-1.478 1.408-1.608H45.2C53.926 61 61 53.926 61 45.2V16.8C61 8.074 53.926 1 45.2 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#social-link-twitter_svg__a)",
    d: "M39.627 17h4.6l-10.05 11.437L46 44h-9.257l-7.251-9.439L21.195 44h-4.603l10.75-12.233L16 17h9.492l6.554 8.628zm-1.615 24.258h2.55l-16.455-21.66h-2.735z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-link-twitter_svg__a",
    x1: 31,
    x2: 31,
    y1: 17,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A51F62"
  })))));
};
export default SvgSocialLinkTwitter;